import { ClientJS } from 'clientjs';

const client = new ClientJS();

export default client;
